import React from "react";
import Header from "../../sharedComponents/header/header";
import AuthorisedOfwca from "./authorisedOfwca/authorisedOfwca";
import ClientContact from "./clientContact/clientContact";
import PreviousInsurerName from "./previousInsurerName/previousInsurerName";
import "./eurofinanceFields.scss";

export default function EurofinanceFields() {
    return (
        <div className="eurofinance-fields">
            <Header type="medium" mainHeader="Eurofinance" />
            <AuthorisedOfwca />
            <ClientContact />
            <PreviousInsurerName />
        </div>
    );
}

